export default "__VITE_ASSET__BO4Kjo3q__"